import * as Yup from 'yup';

/**
 * Yup validation schema for updating a user.
 */
const updateUserValidation = Yup.object({
    name: Yup.string().trim().required('Required'),
    title: Yup.string().trim().required('Required'),
    phone: Yup.string().trim(),
    ext: Yup.string()
        .nullable()
        .trim()
        .matches(/^\d{1,5}$/, {
            message: 'Extension must be 1 to 5 digits',
            excludeEmptyString: true
        })
        .notRequired()
});

export default updateUserValidation;
